//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ValoresPagamentos from './ValoresPagamentos';
import {
  getMoney,
} from '../../../../../../common/functions/helpers';

export default {
  props: {
    valoresPagamentos: {
      type: ValoresPagamentos,
      default: new ValoresPagamentos({}),
    },
    carregando: Boolean,
  },
  methods: {
    getMoney,
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/pagamento/BoxValoresPagamentos.vue?vue&type=script&lang=js&